import React, { useState } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  FormControl,
  FormLabel,
  Input,
  InputGroup,
  InputLeftElement,
  useToast,
  VStack,
  RadioGroup,
  Radio,
  Stack,
  Text
} from '@chakra-ui/react';
import api from '../../../../../services/api';

const ProposalModal = ({ isOpen, onClose, precatorio, onUpdate, state }) => {
  const [valorProposta, setValorProposta] = useState(precatorio?.valor_proposta || '');
  const [action, setAction] = useState('aceitar');
  const [loading, setLoading] = useState(false);
  const toast = useToast();

  const formatCurrency = (value) => {
    const cleaned = value.replace(/\D/g, '');
    const number = parseFloat(cleaned) / 100;
    return number.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    });
  };

  const handleValueChange = (e) => {
    const value = e.target.value.replace(/\D/g, '');
    if (value) {
      setValorProposta(formatCurrency(value));
    } else {
      setValorProposta('');
    }
  };

  const handleSubmit = async () => {
    if (action === 'aceitar' && !valorProposta) {
      toast({
        title: 'Valor obrigatório',
        description: 'Por favor, informe o valor da proposta aceita',
        status: 'warning',
        duration: 3000
      });
      return;
    }

    setLoading(true);
    try {
      const newStatus = action === 'aceitar' ? 'proposta_aceita' : 'proposta_negada';
      
      // Convert formatted currency back to number
      let numericValue = null;
      if (action === 'aceitar' && valorProposta) {
        // Remove currency symbol, spaces, dots (thousand separators) and convert comma to dot
        const cleanValue = valorProposta
          .replace('R$', '')
          .replace(/ /g, '')
          .replace(/\./g, '')
          .replace(',', '.');
        numericValue = parseFloat(cleanValue);
      }
      
      const payload = {
        status: newStatus,
        ...(action === 'aceitar' && { valor_proposta: numericValue })
      };

      const response = await api.put(
        `/contacted-precatorios/${state}/${precatorio._id}/status`,
        payload
      );

      if (response.success) {
        toast({
          title: 'Proposta atualizada',
          description: action === 'aceitar' 
            ? `Proposta aceita no valor de ${valorProposta}. Status atualizado para "Solicitação de Documentos".`
            : 'Proposta negada. Status atualizado.',
          status: 'success',
          duration: 4000
        });
        onUpdate(response.data);
        onClose();
      }
    } catch (error) {
      toast({
        title: 'Erro ao atualizar proposta',
        description: error.response?.data?.message || 'Erro ao processar proposta',
        status: 'error',
        duration: 5000
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          Responder Proposta - {precatorio?.numero_precatorio}
        </ModalHeader>
        <ModalCloseButton />
        
        <ModalBody>
          <VStack spacing={4} align="stretch">
            <FormControl>
              <FormLabel>Ação</FormLabel>
              <RadioGroup value={action} onChange={setAction}>
                <Stack direction="row" spacing={4}>
                  <Radio value="aceitar" colorScheme="green">
                    Aceitar Proposta
                  </Radio>
                  <Radio value="negar" colorScheme="red">
                    Negar Proposta
                  </Radio>
                </Stack>
              </RadioGroup>
            </FormControl>

            {action === 'aceitar' && (
              <FormControl isRequired>
                <FormLabel>Valor da Proposta</FormLabel>
                <InputGroup>
                  <InputLeftElement pointerEvents="none">
                    R$
                  </InputLeftElement>
                  <Input
                    type="text"
                    value={valorProposta}
                    onChange={handleValueChange}
                    placeholder="0,00"
                  />
                </InputGroup>
                <Text fontSize="sm" color="gray.500" mt={1}>
                  Digite o valor acordado com o cliente
                </Text>
              </FormControl>
            )}

            {action === 'negar' && (
              <Text fontSize="sm" color="gray.600">
                Ao negar a proposta, o status será atualizado para "Proposta Negada" 
                e você poderá continuar a negociação ou arquivar o precatório.
              </Text>
            )}
          </VStack>
        </ModalBody>

        <ModalFooter>
          <Button variant="ghost" mr={3} onClick={onClose}>
            Cancelar
          </Button>
          <Button
            colorScheme={action === 'aceitar' ? 'green' : 'red'}
            onClick={handleSubmit}
            isLoading={loading}
          >
            {action === 'aceitar' ? 'Aceitar Proposta' : 'Negar Proposta'}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ProposalModal;